import React, { useState, useEffect, useRef } from 'react';
import cx from 'classnames';
import ReactGA from 'react-ga';

import { Overlay } from '../../UIComponents';
import ClientProfile from '../ClientProfile';
import Loading from '../../common/Loading';
import Layover from './ReportOveralay';
import BlockOverlay from './BlockOverlay';

import helpers from '../helpers';

import './index.scss';

const stopPropagation = {
  onClick: (e) => e.stopPropagation(),
};

const DetailsPane = ({
  conversations,
  selectedConversation,
  visibility,
  onClose,
  postConversationStatus,
  postClientNotes,
  getConversationDetailsbyUser,
  getClientDetails,
  getClientAppointments,
  readNotification,
  getConversationTranscripts,
  auth,
  business,
  erorReport,
  blockUser,
  getBlockUser,
  clearBlockData,
  errorData,
  clearReportFlags,
  editCallerName,
  typeofUser,
  showPaymntinfo,
  StaffManagement,
  selectedLocation,
  callerNameChange,
}) => {
  const [tab, onTabChange] = useState('details');
  const tags = helpers.getAnnotations(selectedConversation);
  const conversationDetails = selectedConversation.details || {};
  let clientsDetails = conversations.clientsDetails || [];
  const clientAppointments = conversations.clientsAppointments;
  const [statusDropdownVisibility, setStatusDropdownVisibility] = useState(
    false,
  );

  const [reportOverlay, setreportOverlayVisibility] = useState(false);

  const [blockOverlay, setblockOverlayVisibility] = useState(false);

  const conversationStatus = { value: 'Report an issue' };
  if (
    selectedConversation.associated_clients &&
    selectedConversation.associated_clients.length > 0
  ) {
    clientsDetails = conversations.clientsDetails;
  } else {
    clientsDetails = [];
  }

  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);
  const prevProps = useRef();
  useOutsideAlerter(wrapperRef, dropdownRef);
  function useOutsideAlerter(ref, dropdownRef) {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setStatusDropdownVisibility(false);
      } else if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setStatusDropdownVisibility(false);
      }
      // }else{
      //   event.preventDefault();
      //   event.stopPropagation();
      // }
    }

    useEffect(() => {
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });
  }

  const handleStatusChange = (event) => {
    if (event !== 'Block') {
      setreportOverlayVisibility(true);
    } else {
      setblockOverlayVisibility(true);
      // getBlockUser(selectedConversation.bzId)
    }
  };

  const tabChange = (selectedTab) => {
    onTabChange(selectedTab);
    ReactGA.set({ dimension1: selectedConversation.id });
    ReactGA.event({
      category: 'Tab',
      action: 'Select Tab',
      label: selectedTab,
    });
  };

  useEffect(() => {
    if (
      selectedConversation.details === undefined ||
      (selectedConversation.details.doApicall &&
        selectedConversation.details.doApicall === true)
    ) {
      let sessionIdArray = [];
      sessionIdArray = selectedConversation.otherconversation.map(
        (conversation) => {
          return conversation.id;
        },
      );
      sessionIdArray.push(selectedConversation.id);
      getConversationDetailsbyUser({
        businessId: selectedConversation.bzId,
        sessionId: sessionIdArray,
        rootid: selectedConversation.id,
        convuserId: selectedConversation.userId,
        selectedConversation,
      });
      if (
        selectedConversation.notification_read_status === 'UNREAD' &&
        selectedConversation.unread_count > 0
      ) {
        selectedConversation.notification_read_status_details = 'UNREAD';
        readNotification(selectedConversation.bzId, selectedConversation.id);
      } else {
        selectedConversation.notification_read_status_details = 'READ';
      }
    }
  }, [selectedConversation]);

  useEffect(() => {
    if (
      (selectedConversation.associated_clients &&
        selectedConversation.associated_clients.length > 0) ||
      (selectedConversation.details &&
        selectedConversation.details.bookings &&
        selectedConversation.details.bookings.length > 0) ||
      (selectedConversation.details &&
        selectedConversation.details.messages &&
        selectedConversation.details.messages.length > 0) ||
      (selectedConversation.details &&
        selectedConversation.details.notes &&
        selectedConversation.details.notes.conversation_notes &&
        selectedConversation.details.notes.conversation_notes.length > 0)
    ) {
      let clientIdArray = selectedConversation.associated_clients.map(
        (booking) => booking.id,
      );
      let bookingIdArray = selectedConversation.bookings.map(
        (booking) => booking.client_id,
      );
      clientIdArray = clientIdArray.concat(bookingIdArray);
      clientIdArray = new Set(clientIdArray);
      let clients = [...clientIdArray];
      if (clients.length > 0) {
        getClientDetails({
          businessId: selectedConversation.bzId,
          clients,
        });
      }
    }
  }, [selectedConversation.details]);

  // useEffect(() => {
  //   if (callerNameChange) {
  //     let clientIdArray = selectedConversation.associated_clients.map(
  //       (booking) => booking.id,
  //     );
  //     let bookingIdArray = selectedConversation.bookings.map(
  //       (booking) => booking.client_id,
  //     );
  //     clientIdArray = clientIdArray.concat(bookingIdArray);
  //     clientIdArray = new Set(clientIdArray);
  //     let clients = [...clientIdArray];
  //     getClientDetails({
  //       businessId: selectedConversation.bzId,
  //       clients,
  //     });
  //   }
  // }, [callerNameChange]);

  return (
    <div className={cx('pane-container', { open: visibility })}>
      <Overlay onOverlayClick={onClose} style={{ zIndex: 100 }}>
        <div className="pane details-pane" {...stopPropagation}>
          <header className="pane__header header">
            <div className="header__info">
              <h4 className="header__info__name">
                {helpers.getclientNameList(selectedConversation, typeofUser)}
              </h4>
              <p
                className={cx('header__info__phone', {
                  unwrap:
                    helpers.getClientPhone(selectedConversation).length > 35,
                })}
              >
                {helpers.getClientPhone(selectedConversation)}
              </p>
              <a
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                }}
                className="header__info__close"
              >
                &times;
              </a>
            </div>
          </header>
          <div className="pane__content">
            {!selectedConversation.details ? (
              <div className="tabs-content">
                <div className="tabs-content__loader">
                  <Loading />
                </div>
              </div>
            ) : (
              <div className="tabs-content">
                <ClientProfile
                  selectedConversation={selectedConversation}
                  getClientAppointments={getClientAppointments}
                  clients={clientsDetails}
                  appointments={clientAppointments}
                  businessId={selectedConversation.bzId}
                  conversations={conversations}
                  auth={auth}
                  typeofUser={typeofUser}
                  showPaymntinfo={showPaymntinfo}
                  editCallerName={editCallerName}
                />
              </div>
            )}
          </div>
        </div>
      </Overlay>
      {reportOverlay && (
        <Layover
          setreportOverlayVisibility={setreportOverlayVisibility}
          modelopen={true}
          name={helpers.getNameform(selectedConversation)}
          phone={helpers.getClientPhone(selectedConversation)}
          selectedConversation={selectedConversation}
          auth={auth}
          business={business}
          erorReport={erorReport}
          errorData={errorData}
          clearReportFlags={clearReportFlags}
          globalReport={false}
          typeofUser={typeofUser}
          selectedLocation={selectedLocation}
        />
      )}
      {blockOverlay && (
        <BlockOverlay
          setblockOverlayVisibility={setblockOverlayVisibility}
          modelopen={true}
          phone={helpers.getClientPhone(selectedConversation)}
          selectedConversation={selectedConversation}
          auth={auth}
          business={business}
          blockUser={blockUser}
          errorData={errorData}
          getBlockUser={getBlockUser}
          clearBlockData={clearBlockData}
          clearReportFlags={clearReportFlags}
          globalReport={false}
          typeofUser={typeofUser}
          selectedLocation={selectedLocation}
        />
      )}
    </div>
  );
};

export default DetailsPane;
